import { render, staticRenderFns } from "./toDictionary.vue?vue&type=template&id=5ca3e9c6&scoped=true"
import script from "./toDictionary.vue?vue&type=script&lang=js"
export * from "./toDictionary.vue?vue&type=script&lang=js"
import style0 from "./toDictionary.vue?vue&type=style&index=0&id=5ca3e9c6&prod&scoped=true&lang=css"
import style1 from "./toDictionary.vue?vue&type=style&index=1&id=5ca3e9c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca3e9c6",
  null
  
)

export default component.exports